module.exports = __webpack_public_path__ + "static/media/electricity_bulb.dc28b75b.png";